import { useTranslation } from 'react-i18next'
import { Button } from '../../Button'
import { RefreshCw } from 'lucide-react'

type RecordPropertyStaleProps = {
  onRecalculateClick?: () => void
}

export function RecordPropertyStale (props: RecordPropertyStaleProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2 justify-between px-2 py-1 h-full bg-warning/10 rounded-md">
      <span className="text-xs text-warning font-semibold">{t('Stale cell')}</span>
      <Button
        onClick={props.onRecalculateClick}
        size="xs"
        ghost
        className="hover:bg-warning/50 rounded-full"
        color='warning'
      >
        <RefreshCw size={16} />
      </Button>
    </div>
  )
}
